import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { startCase } from 'lodash';
let BackButton = class BackButton extends Vue {
    get splitRoute() {
        return this.$route.path.split('/');
    }
    get parentRoute() {
        return this.splitRoute.slice(0, this.splitRoute.length - 1).join('/');
    }
    get parentRouteName() {
        const parentPosition = this.splitRoute.length - 2;
        return startCase(this.splitRoute.slice(parentPosition, parentPosition + 1)[0]);
    }
};
__decorate([
    Prop(String)
], BackButton.prototype, "label", void 0);
BackButton = __decorate([
    Component
], BackButton);
export default BackButton;
